// The homepage's time filter (Today / 7 days / 30 days / a calendar day)
// lives in React state, not the URL — it's a filter, not a route. That
// means a <Link href="/"> from the sidebar or header is a no-op when you're
// already on "/", so the logo and "Today" would leave a 30-day view up.
//
// The nav lives in the layout and the filter lives in the page, so they
// can't share state directly. A one-line event closes the gap: home links
// announce "take me to the default view" and the homepage listens.
export const HOME_RESET_EVENT = 'pano:home-reset'

// Call from a link to "/" — harmless anywhere, since only the homepage
// listens and a real navigation resets the state by mounting fresh.
export function requestHomeReset() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(HOME_RESET_EVENT))
  }
}
